import React from 'react';

const Settings: React.FC = () => {
  console.log('Future Settings Page');
  return (
    <div>
      Future Settings Page
    </div>
  );
};

export default Settings;
